import React from "react";
import { TopBar } from "@client/components/dashboard/TopBar";
import { LayoutRoot } from "@client/components/layout/LayoutRoot";
import { AppErrorBoundary } from "@client/components/ui/error-boundary";
import { useGlobalShortcuts } from "@client/hooks/useShortcuts";
import { useUIStore } from "@client/store/ui";

const App: React.FC = () => {
  const devMessage = useUIStore((s) => s.devMessage);
  useGlobalShortcuts();

  return (
    <div className="min-h-screen bg-background text-foreground">
      {import.meta.env.MODE === "development" && devMessage && (
        <div className="fixed top-2 left-2 z-50 rounded bg-status-warning text-white text-xs px-2 py-1 shadow-lg">{devMessage}</div>
      )}

      <AppErrorBoundary>
        <TopBar />
      </AppErrorBoundary>

      <main>
        <AppErrorBoundary>
          {/* Dashboard se renderuje přes modulární layout engine (default replikuje původní strukturu). */}
          <LayoutRoot layoutKey="dashboard" />
        </AppErrorBoundary>
      </main>
    </div>
  );
};

export default App;
